import { render, staticRenderFns } from "./DashboardTodos.vue?vue&type=template&id=5f26f816&scoped=true&"
import script from "./DashboardTodos.vue?vue&type=script&lang=js&"
export * from "./DashboardTodos.vue?vue&type=script&lang=js&"
import style0 from "./DashboardTodos.vue?vue&type=style&index=0&id=5f26f816&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f26f816",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText,VCardTitle})
